// extracted by mini-css-extract-plugin
module.exports =  {"container":"_7a3fb80146--container--wpxx7","container-inner":"_7a3fb80146--container-inner--zJMnR","image":"_7a3fb80146--image--YiUeJ","controls":"_7a3fb80146--controls--T1lZf"};